export const getCashRequestApprovals = (state) =>
  state.cashRequestApprovals.results;